// Persists the live experience-attempt context to the diagnostics cache while
// the user is in an experience (MV-1077). Renders nothing — it's mounted in the
// in-experience tree (HomeBottomBar) so that if the experience later fails or
// crashes and the app navigates back to the event-selection screen (unmounting
// the stream providers), a Report It filed from there still carries the
// streaming correlation ids. The failure *reason* is stamped separately at the
// navigation funnel (navigateToEventsPage -> recordExperienceFailure).

import { useEffect } from 'react';

import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { recordExperienceContext } from '@services/reportIt/experienceDiagnostics';

const ReportItDiagnosticsSync = (): null => {
  const { websocketSessionId } = useMytaverse();
  const event = useMytaverseEvent();

  const eventId = event?.currentEvent?.eventId || event?.currentEventId;
  const streamGroupId = event?.gameCastStreamId;
  const region = event?.gameCastStreamRegion;

  useEffect(() => {
    if (!websocketSessionId && !eventId && !streamGroupId) {
      return;
    }

    recordExperienceContext({
      eventId: eventId || undefined,
      entities: {
        websocketSessionId: websocketSessionId || undefined,
        streamGroupId: streamGroupId || undefined,
        region: region || undefined,
      },
      // A stream id means the session reached the GameCast layer; otherwise the
      // user is still attempting entry.
      outcome: streamGroupId ? 'active' : 'attempting',
    });
  }, [websocketSessionId, eventId, streamGroupId, region]);

  return null;
};

export default ReportItDiagnosticsSync;
